import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { sdClient } from 'contexts/SDKClientContext';
import { UsersTableCellProps } from 'pages/Settings/Users/UsersTable';
import { updateUser } from 'utils/user';
import { RFC822_VALID_EMAIL_REGEX } from 'utils/validation';

const emailValidation = (newEmail: string | undefined) => {
    if (!newEmail) {
        return 'Email required';
    }

    if (newEmail.includes(',')) {
        return 'Commas are not allowed';
    }

    const emailRegex = new RegExp(RFC822_VALID_EMAIL_REGEX);
    if (!emailRegex.test(newEmail)) {
        return 'Enter a valid email';
    }

    return undefined;
};

export function UserEmailCell({ rowData, onChange }: UsersTableCellProps) {
    const { canEditUserProperties } = usePermissions();
    const onSave = async (newEmail: string | undefined) => {
        if (!newEmail) {
            throw new Error('Attempted to save without an email');
        }

        if (await sdClient.checkEmailExists({ email: newEmail })) {
            return 'Email already exists, please enter a unique email';
        }

        try {
            await updateUser(rowData.Id, { Email: newEmail });
            onChange();
        } catch {
            return 'Unable to save email';
        }
        return undefined;
    };
    return (
        <div>
            <TextInlineEditor
                onConfirm={onSave}
                value={rowData.Email}
                validate={emailValidation}
                isDisabled={!canEditUserProperties}
            />
        </div>
    );
}
